﻿<template>
    <div v-if="modal.show && modal.active" class="modal-mask" transition="modal">
        <div class="modal-wrapper">         
          <div v-bind:class="(modal.context == 'signingDigital') ? 'modal-container modal-container-large' : 'modal-container'">              
               <span v-if='modal.icon == "norlysred"' class='ca-modal-norlys'> <img class="ts-section__norlys" src="/ui/svg/norlys_icon.svg" data-variant="29" data-animated="true" data-has-fallback="true"/></span>
               <span v-if='modal.icon == "warning"' class='ca-modal-warning'><img class="ca-modal__warning" src="/ui/svg/ico-error-full.svg" /></span>
               <span v-if='modal.icon == "info"' class='ca-modal-info'><img class="ca-modal__info" src="/ui/svg/info-icon.svg" /></span>
                <!-- fix stylesheet -->
                <div class="modal-header">
                </div>
                <div class="modal-body">
                    <h4 v-if="modal.headline !== null && modal.headline.length > 0">
                        {{modal.headline}}
                    </h4>
                  <br/>
                    <p v-bind:class="(modal.context == 'signingDigital') ? 'align-left' : ''">{{modal.message}}</p>                
                  <br/>
                  <div v-if="modal.context == 'signingDigital'" class="ca-signatures-required align-left">
                    <br/>
                    <div class="ts-product-table">
                      <div class="ts-product-table__head">
                        <div class="row">
                          <div class="columns large-4 medium-4">
                            <p class="ts-text-highlight">{{modal.digitalSignatureLabels.name}}</p>
                          </div>
                          <div class="columns large-5 medium-5">
                            <p class="ts-text-highlight">{{modal.digitalSignatureLabels.contracts}}</p>
                          </div>
                          <div class="columns large-3 medium-3">
                            <p class="ts-text-highlight">{{modal.digitalSignatureLabels.sign}}</p>
                          </div>
                        </div>
                      </div>
                      <div class="ts-product-table__content">
                        <div v-for ="signer in digitalSigningModal.signatures"  class="ts-product-table-item">
                          <div class="ts-product-table-item__content">
                            <div class="row">
                              <div class="columns large-4 medium-4">
                                <div class="ts-product-table-item__specs">
                                  <p class="ts-product-table-item__name">{{signer.FullName}}</p>
                                </div>
                              </div>
                              <div class="columns large-5 medium-5">
                                <ul v-if="!signer.FlagedSignature">
                                <li>Telia Contract</li>
                                  <li v-if="showTFSummaryInformation">TF Contract</li>
                                </ul>
                                <ul v-if="signer.FlagedSignature == true && signer.SignatureDetails">
                                  <li v-for ="document in signer.SignatureDetails">
                                    <span v-if="document.SignaturesName == 'PRIVATE_PORTING' || document.SignaturesName == 'PRIVATE_TRANSFER'"> {{mapDocumentTypeValue(document.SignaturesName)}}</span>
                                    </li>
                                    </ul>
                              </div>
                              <div class="columns large-3 medium-3">                               
                                <button class="ts-button" v-if="!signer.MarkedAsSigned" v-on:click="showEpadModalDialog(signer.FullName)">Sign</button>
                                <ul class="ts-checklist"  v-if="signer.MarkedAsSigned">
                                  <li class="ts-checklist__item">
                                    <svg role="img" class="ts-symbol ts-symbol--tick ts-checklist__symbol ts-checklist__symbol--success" aria-hidden="true">
                                      <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/Ui/ECommerce/images/sprite/svg-symbols.svg#tick"></use>
                                    </svg>
                                   </li>
                                </ul>

                              </div>
                            </div>
                          </div>
                        </div>
                        </div>
                    </div>
                  </div>
                </div>
                <div id="modalFooter" class="modal-footer">
                </div>
              <div class="clearfix"></div>
            </div>
        </div>
    </div>
</template>
<script>
  import { mapGetters, mapState } from 'vuex';
  import mixins from './mixins.js';
  
  export default {
    name: 'alert-modal',
    mixins: [mixins],
    mounted: function() {
      this.$store.watch(state => state.creditaccount.alertModal.show, (newState) => {
      if(newState === true){
        var self = this;        
        var footer = document.getElementById("modalFooter");
        while (footer.lastChild) {
          footer.removeChild(footer.lastChild);
        }
        const classAttSingleButton = self.modal.buttons.length > 1 ? '' : '-single';

        self.modal.buttons.forEach(function(item){
        let button = document.createElement('button');

        let classAtt = document.createAttribute("class");
        let classAttValue = (["cancel", "refresh", "retryCreditCheck", "retryPreAuth", "resubmit", "submit"].indexOf(item) > -1) ? 'modal-green-800-button': 'modal-default-button';
        classAtt.value = classAttValue + classAttSingleButton;
        button.setAttributeNode(classAtt);

        button.innerText = self.buttonTexts[item];
        button.onclick = self[item];

        footer.appendChild(button);
      });
    }
  });
  },
  computed:
  Object.assign(
  mapState({
  modal: state => state.creditaccount.alertModal,
  order: state => state.creditaccount.order,
  pageDetails: state => state.creditaccount.pageDetails,
  buttonTexts: state => state.creditaccount.buttonTexts,
  pageLoader: state => state.creditaccount.pageLoader,
  contracts: state => state.creditaccount.contracts,
  digitalSigningModal: state => state.creditaccount.digitalSigningModal,
  showTFSummaryInformation : state => state.creditaccount.showTFSummaryInformation,
  salesChannel : state => state.creditaccount.salesChannel
  }),
  mapGetters({
  pageDetails: 'pageDetails'
  })
  ),
  methods: {
  close: function () {
  this.$store.dispatch('hideModal');
  },
  closeContinue: function () {
  this.close();
  },
  refresh: function(){
  window.location.reload();
  },
  cancel: function(){
  this.$store.dispatch('cancelOrder', this.pageDetails.tangoRedirectUrl);
  this.close();
  },
  retryCreditCheck: function(){
  this.$store.dispatch('externalCreditCheck', {
  'loaderTitle': this.pageLoader.loaderCreditCheckTitle,
  'loaderMessage': this.pageLoader.loaderCreditCheckMessage
  });
  this.close();
  },
  retryPreAuth: function(){
  this.$store.dispatch('getPreAuth', {
  'loaderTitle': this.pageLoader.loaderPreAuthTitle,
  'loaderMessage': this.pageLoader.loaderPreAuthMessage
  });
 },
retryJoiceCreditCheck: function () {
    this.$store.dispatch('getJoiceCreditCheck', {
        'loaderTitle': this.pageLoader.loaderCreditCheckTitle,
        'loaderMessage': this.pageLoader.loaderCreditCheckMessage
          });
      },

  submit: function(){
  this.$store.dispatch('signContracts', {'orderId': this.order.orderId, 'dealerCode': this.order.dealerCode, 'channelType': this.order.channelType, 'userId': this.order.salesAgent, 'signatureString' : "", 'loaderTitle': this.pageLoader.loaderSubmitOrderTitle, 'loaderMessage': this.pageLoader.loaderSubmitOrderMessage});
  this.close();
  },
  resubmit: function(){
  if(this.salesChannel == 'PhysicalShop')
  {
  this.$store.dispatch('submitOrder');
  }
  else if(this.salesChannel == 'Telesales')
  {
  this.$store.dispatch('submitOrderForRemoteChannel');
  }
  else
  {
  alert("The submition of an order from 'this.salesChannel' is not suported!");
  }
  this.close();
  },
  returnToTango: function(){     
      window.location = this.pageDetails.tangoRedirectUrl + "/Default.aspx?mode=ordering&previousOrderGuid=" + this.order.orderGuid;
        },
        showEpadModalDialog: function(signerName)
        {
            this.$store.dispatch('setSelectedSigner', signerName);
            this.signNow();
        },
        mapDocumentTypeValue: function(value){
            switch(value){
                case 'PRIVATE_PORTING':
                    return 'Contract for porting of number';
                case 'PRIVATE_TRANSFER':
                    return 'Contract for transfer of number';
                default:
                    return value;
            }
        }},
    ready: function () {
        document.addEventListener("keydown", (e) => {
            if (this.modal.show && e.keyCode == 27) {
                this.close();
            }
        });
    }
    }
</script>
